export default "__VITE_ASSET__C8_fwvf4__"